import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  Type,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { IconType } from '@ng-icons/core';

export interface Tab {
  label: string;
  component: any;
  icon?: IconType;
}

@Component({
    selector: 'mot-tabs',
    templateUrl: './mot-tabs.component.html',
    styleUrls: ['./mot-tabs.component.scss'],
    standalone: false
})
export class MotTabsComponent {
  @Output() selectedTabChange = new EventEmitter<any>();

  @Input() class: string;
  @Input() tabs!: Tab[];
}
